<template>
  <div class="feeInfoDateInputWrapper">
    <date-picker v-model="date"
                 v-bind:value="this.date"
                 v-bind:calendar-class="{feeInfoDateCalendarStyle : true}"
                 v-bind:input-class="{feeInfoDatePickerStyle : true}"
                 v-bind:language="korean"
                 v-bind:format="'yyyy.MM.dd'"
                 v-on:closed="dateSelected">
    </date-picker>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker'
import { ko } from 'vuejs-datepicker/dist/locale'

export default {
  props: {
    type: String
  },
  data () {
    return {
      date: null,
      korean: ko
    }
  },
  components: {
    'date-picker': Datepicker
  },
  methods: {
    dateSelected: function () {
      this.$store.commit('setSearchDate', {type: this.type, value: this.date})
    }
  },
  created: function () {
    this.date = this.$store.getters.getSearchDate(this.type)
  }
}
</script>

<style>
.feeInfoDatePickerStyle{
  padding-left: 28px;
  font-size: 13px;
  width: 133px;
  height: 48px;
  text-align: center;
  background-color: #F2F2F2;
  border-radius: 8px;
  border: none;
  outline: none;
  background-image: url('../../../assets/img/calander_input_icon.png');
  background-size: 32px 32px;
  background-repeat: no-repeat;
  background-position: 8px 50%;
}

.feeInfoDateCalendarStyle{
  font-size: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/board/elements/feeInfoDateInput.vue